import React from 'react';
import {
  FormControl,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
} from '@mui/material';

const WorkerCommandTypeField = ({ value, onChange, disabled }) => {
  const handleChange = (event) => {
    onChange(event, {
      name: 'worker_command_type',
      value: event.target.value,
    });
  };

  return (
    <FormControl component='fieldset' disabled={disabled}>
      <FormLabel component='legend'>Command Type</FormLabel>
      <RadioGroup
        name='worker_command_type'
        value={value}
        onChange={handleChange}
      >
        <FormControlLabel
          value='different'
          control={<Radio />}
          label='Different Command For Each Worker'
        />
        <FormControlLabel
          value='same'
          control={<Radio />}
          label='Same Command For All Workers'
        />
      </RadioGroup>
    </FormControl>
  );
};

export default WorkerCommandTypeField;

